import React from 'react';
import { Link } from 'react-router-dom';

interface ThankYouMessageProps {
  /** True when the order joins the classroom's one-time Class Shipment (pooled). */
  isClassShipment?: boolean;
}

const ThankYouMessage: React.FC<ThankYouMessageProps> = ({ isClassShipment }) => {
  return (
    <div className="flex flex-col justify-center items-center gap-2 h-[82vh]">
      <p className="text-2xl">Thank you for your order!</p>
      <p className="text-base text-gray-600 max-w-md text-center px-4">
        {isClassShipment
          ? '📦 Your book is reserved for the Class Shipment — it will be printed with the whole class\'s orders, delivered to the school, and handed out by the teacher. 🎉'
          : '🚚 Your book prints now and ships to the address you entered. Your order confirmation is on its way by email.'}
      </p>
      <p className="text-2xl mt-4">Would you like to go back to the application?</p>
      <Link
        to="/"
        className="flex justify-center items-center text-white text-base font-sm bg-storyblue rounded-2xl px-4 py-2 shadow-xl font-bold capitalize mt-2"
      >
        Continue
      </Link>
    </div>
  );
};

export default ThankYouMessage;
